import { render, staticRenderFns } from "./ServiceSubcategories.vue?vue&type=template&id=0befe833"
import script from "./ServiceSubcategories.vue?vue&type=script&lang=js"
export * from "./ServiceSubcategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports